import { legacy_createStore as createStore } from 'redux';
// import { compose } from 'redux'; //development only
import { initialState } from './initialState';
import { reducers } from './reducers';

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; //development only

// const store = createStore(reducers, initialState, composeEnhancers()); //development only
const store = createStore(reducers, initialState); //production only
export * as actions from './actions';
export * as reducers from './reducers';
export default store;
